<template>
    <div>
        <h1>Collaboration</h1>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    }
}

</script>



// WEBPACK FOOTER //
// src/views/portfolio/Content/Collaboration.vue